import RegistrationService from '../../services/registration.service'
import ActionTypes from '../types'

const FetchRegistrationStatusRequest = () => ({
  type: ActionTypes.FETCH_REGISTRATION_STATUS_REQUEST,
  payload: null
})

const FetchRegistrationStatusError = error => ({
  type: ActionTypes.FETCH_REGISTRATION_STATUS_ERROR,
  payload: error
})

const FetchRegistrationStatusSuccess = payload => ({
  type: ActionTypes.FETCH_REGISTRATION_STATUS_SUCCESS,
  payload
})

export const fetchRegistrationStatus = eventId => dispatch => {
  dispatch(FetchRegistrationStatusRequest())
  RegistrationService.fetchRegistrationStatus(eventId)
    .then(response => dispatch(FetchRegistrationStatusSuccess(response)))
    .catch(error => dispatch(FetchRegistrationStatusError(error)));
}
